import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, continuity, continuityCnname, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let treeChildren = (data, index) => {
  var arr = [];
  var shape = ['大', '小', '单', '双'];
  var str = ['big', 'small', 'single', 'double'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      // obj.width = '37';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        var name = `ball${index + 1}`;
        var num = row.row.ball_history_json[name][str[i]];
        return <span>{num ? num : 0}</span>;
      };
      arr.push(obj);
    }
    return arr;
  }
};

const pk10 = data => {
  let list = Vue => {
    let arr = [
      {
        title: '日期',
        align: 'center',
        key: 'date',
        className: `table_issueId`,
        width: 90
      }
    ];
    var a = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
    // var keys = Object.keys(data[0].ball_history_json);
    for (let i = 0; i < 10; i++) {
      let obj = {};
      let e = a[i];
      obj.title = `第${e}球`;
      obj.align = 'center';
      obj.width = '300';
      obj.key = 'resultStr';
      obj.className = `table_info_column_${i}`;
      obj.children = treeChildren(data, i);
      arr.push(obj);
    }
    return arr;
  };

  return { list };
};

export default pk10;



// WEBPACK FOOTER //
// ./src/pages/Trend/Daxiaodanshuanglishi/columns/pk10.js